var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('h1',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.$t("common.acronym"))+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Manutenzione sito in corso. Ci scusiamo per il disagio.")]),_c('p'),_c('h1',[_vm._v("Website maintenance in progress.")])])
}]

export { render, staticRenderFns }